export function SpriteIcon ({ id, size, className }: {
  id: string
  size: number
  className?: string
}): JSX.Element {
  return (
    <svg
      width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'
      className={className} aria-hidden='true'
    >
      <use href={`#${id}`} />
    </svg>
  )
}
